import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
    FetchGetServicesRequestByIdthunk, 
    FetchGetServiceDefinitionByIdthunk
} from "../../../../Redux/ServicesRequests/ServicesRequestsAction";
import { resetGetServicesRequestByIdData } from "../../../../Redux/ServicesRequests/ServicesRequestsSlice";
import { 
    FetchEligibleSemenCollectionCertificatesthunk 
} from "../../../../Redux/InternationalBreedingCertificate/internationalBreedingCertificateAction";
import { 
    resetToasterMessage 
} from "../../../../Redux/InternationalBreedingCertificate/internationalBreedingCertificateSlice";
import { IBC_SERVICE_DEFINITION_ID } from "../utils/InternationalBreedingCertificateConstants";
import { ServiceActionTypes } from "../../shared/utils/ServicesConstants";
import { getCountries, getHorseColors } from "../../../sharedAPI/lookUpApis";

export const useInternationalBreedingCertificateData = (id, selectedOwnerId, currentLanguage, action) => {
    const dispatch = useDispatch();

    const [colors, setColors] = useState([]);
    const [countries, setCountries] = useState([]);
    const [lookupsLoading, setLookupsLoading] = useState(true);

    const { isLoading, eligibleCertificatesData, toasterMessage, createOrEditIBCData } = useSelector(
        (state) => state.internationalBreedingCertificateSlice || {}
    );
    const { 
        getServicesRequestByIdData, 
        getServiceDefinitionByIdData, 
        servicesRequestsLoading 
    } = useSelector((state) => state.servicesRequestsSlice || {});

    // Load static lookups
    useEffect(() => {
        let isMounted = true;
        Promise.all([
            getHorseColors().catch(() => []),
            getCountries().catch(() => [])
        ]).then(([colorsRes, countriesRes]) => {
            if (isMounted) {
                setColors(colorsRes || []);
                setCountries(countriesRes || []);
                setLookupsLoading(false);
            }
        });

        return () => {
            isMounted = false;
        };
    }, []);

    // Main request & definitions
    useEffect(() => {
        if (id) {
            dispatch(FetchGetServicesRequestByIdthunk({ 
                id: id, 
                ownerId: selectedOwnerId, 
                language: currentLanguage 
            }));
        }

        dispatch(FetchGetServiceDefinitionByIdthunk(IBC_SERVICE_DEFINITION_ID));

        if (action !== ServiceActionTypes.VIEW) {
            dispatch(FetchEligibleSemenCollectionCertificatesthunk(selectedOwnerId));
        }

        return () => {
            dispatch(resetGetServicesRequestByIdData());
        };
    }, [id, currentLanguage, dispatch, selectedOwnerId, action]);

    const fetchEligibleCertificates = (ownerId) => {
        dispatch(FetchEligibleSemenCollectionCertificatesthunk(ownerId));
    };

    const clearToasterMessage = () => {
        dispatch(resetToasterMessage());
    };

    return {
        IBC_SERVICE_DEFINITION_ID,
        isLoading: Boolean(isLoading || servicesRequestsLoading || lookupsLoading),
        toasterMessage,
        clearToasterMessage,
        eligibleCertificatesData: eligibleCertificatesData || [],
        getServicesRequestByIdData,
        getServiceDefinitionByIdData,
        colors,
        countries,
        createOrEditIBCData,
        fetchEligibleCertificates
    };
};
